module.exports = __webpack_public_path__ + "static/media/Claro-logo.71a586fc.png";